import React, { Component } from "react";
import EmptyState from "@atlaskit/empty-state";
import { UserContext } from "../../Context";

import Button from "@atlaskit/button";

import GuarenteeIcon from "../../assets/guarentee__icon.png";

export default class LoggedOutContent extends Component {
  render() {
    return (
      <UserContext.Consumer>
        {userContext => (
          <div className="logged-out-content">
            <EmptyState
              header={this.props.header || "Please Login To Continue"}
              description={
                this.props.description ||
                `You're just steps away from the easiest rental process ever designed. Login to get started.`
              }
              imageUrl={this.props.imageUrl || GuarenteeIcon}
              size={this.props.size || "narrow"}
              maxImageWidth={this.props.maxImageWidth || 304}
              maxImageHeight={this.props.maxImageHeight || 304}
              primaryAction={
                <Button
                  onClick={
                    userContext.user
                      ? this.logout
                      : userContext.loginModalHandler
                  }
                  appearance="primary"
                >
                  Login
                </Button>
              }
            />
          </div>
        )}
      </UserContext.Consumer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/LoggedOutContent/LoggedOutContent.js